import React, { Component } from 'react';
import './radioButtonText.css';

class RadioButtonText extends Component {

  renderColor(item) {
    if (this.props.selectedItem === item) {
      return {color: '#fff', background: '#6A93A8'}
    } else {
      return {color: '#6A93A8'}
    }
  }

  render() {
    return(
      <div>
        <div className="user-row">

          <div className="radiobutton-text-wrapper">
              {
                Object.keys(this.props.data).map(item =>
                  <div
                    key={item}
                    style={{color: this.renderColor(item).color, background: this.renderColor(item).background}}
                    onClick={() => this.props.setItem(item)}
                    className="select-button drop-shadow"
                  >

                    {this.props.data[item]}

                  </div>
                )
              }
          </div>


          {this.props.companyLogo.length > 0 &&
            <div className="user-avatar-company-logo">
              <img
                src={`${this.props.companyLogo}`}
                alt=""
                style={{width: '100%'}}
              />
            </div>
          }

          {this.props.companyLogo.length === 0 &&
            <div className="user-avatar">
              {this.props.companyName.charAt(0).toUpperCase()}
            </div>
          }
        </div>
      </div>
    )
  }
}

export default RadioButtonText;
